import styled from 'styled-components';

export const ColumnWrapper = styled.div`
  flex: 1 0 0;
`;
